import { getCategories } from '@/api/categories-api';
import types from './types';

const actions = {
  async FETCH_CATEGORIES(store: any) {
    try {
      const categoriesResult = await getCategories();

      store.commit(types.mutations.SET_CATEGORIES, categoriesResult.data);
    } finally {
      return Promise.resolve();
    }
  }
};

export default actions;
